import * as React from 'react'
import { IconWrapper } from '../IconWrapper'
import { IconProps } from '../iconConstants'

export const InfoQuestionMarkIcon = ({ title, titleId, ...props }: IconProps) => (
    <IconWrapper {...props}>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1em"
            height="1em"
            fill="none"
            viewBox="0 0 24 24"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <circle cx={12} cy={12} r={9.5} stroke="currentColor" />
            <path
                fill="currentColor"
                stroke="currentColor"
                d="M12 15.5a.25.25 0 0 0-.049.495.25.25 0 0 0 .299-.245.25.25 0 0 0-.25-.25Z"
            />
            <path
                stroke="currentColor"
                d="M9.5 10c0-.833.5-2.5 2.5-2.5s2.5 1.667 2.5 2.5c0 .667-.3 1.6-1.5 2-1.2.4-1 1.5-1 2"
            />
        </svg>
    </IconWrapper>
)
